/**
 * Viewer-local "DD Mon YYYY, HH:MM" (24-hour) stamp, shared by the Updated column
 * and the ETA display so the two never drift. Assumes a valid ISO-8601 string.
 */
export function formatLocalDateTime(iso: string): string {
  return new Date(iso).toLocaleString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}
